import type { ReactNode } from 'react';

export const symbol_ev_shadow: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m383-325 365-365q-14-17-30-32t-33-29L351-417q5 25 13 47.5t19 44.5Zm416-38q19-49 21-103L531-176q11 5 24.5 11t24.5 10q51-16 93.5-45.5T748-272q32-42 51-91ZM140-480q0 140 97.5 239T475-140q-86-54-138-142.5T285-480q0-109 52.5-197.5T476-820q-140 2-238 100.5T140-480Zm338 271 336-336q-5-25-13.5-48T781-638L416-273q19 24 30.5 35.5T478-209Zm-154 97.5Q251-143 197-197t-85.5-127Q80-397 80-480t31.5-156Q143-709 197-763t127-85.5Q397-880 480-880t156 31.5Q709-817 763-763t85.5 127Q880-563 880-480t-31.5 156Q817-251 763-197t-127 85.5Q563-80 480-80t-156-31.5ZM345-495l288-289q-12-6-24-11t-25-9q-101 31-167.5 115.5T345-495Zm238 15Z"
		/>
	</svg>
);
